<script setup lang="ts">
const isSticky = ref(false);

const handleScroll = () => {
	isSticky.value = window.scrollY > 20;
};

const initializeHamburgerAnimation = () => {
	const mobileNavBurger = document.querySelector(".mobile-nav-burger");
	const navbarCollapse = document.querySelector(".navbar-collapse");

	if (mobileNavBurger) {
		mobileNavBurger.addEventListener("click", (e) => {
			e.preventDefault();
			mobileNavBurger.classList.toggle("is-active");

			if (navbarCollapse) {
				navbarCollapse.classList.toggle("show");
			}
		});
	}
};

onMounted(() => {
	window.addEventListener("scroll", handleScroll);
	initializeHamburgerAnimation();
});

onUnmounted(() => {
	window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
	<div>
		<nav class="navbar-main"
			role="navigation"
			aria-label="Menu principal">
			<div :class="`navbar-main-wrapper ${isSticky ? 'fixed-after-scroll' : ''}`">
				<div class="navbar navbar-expand-lg">
					<div class="alignwide">
						<a class="navbar-logo"
							href="/ifen/"
							aria-label="Accueil - Logo de l'Institut de Formation de l'Éducation Nationale">
							<svg xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								width="316.827"
								height="87.755"
								viewBox="0 0 316.827 87.755">
								<title>Logo Ifen (Institut de Formation de l'Éducation Nationale)</title>
								<g id="Groupe_942"
									data-name="Groupe 942"
									transform="translate(-230 -54.995)">
									<g id="Groupe_542"
										data-name="Groupe 542"
										transform="translate(230 54.995)">
										<g id="Groupe_541"
											data-name="Groupe 541">
											<path id="Tracé_175"
												class="scroll-fade"
												data-name="Tracé 175"
												d="M39.181,105.972a3.177,3.177,0,0,0-2.96,1.657,5.6,5.6,0,0,0-.49,2.9v22.526a5.6,5.6,0,0,0,.493,2.9,3.472,3.472,0,0,0,5.913,0l0-.006a5.6,5.6,0,0,0,.49-2.895V110.524a5.6,5.6,0,0,0-.493-2.9,3.175,3.175,0,0,0-2.956-1.652"
												transform="translate(-16.848 -49.967)"
												fill="#000a40" />
											<path id="Tracé_176"
												class="scroll-fade"
												data-name="Tracé 176"
												d="M73.519,88.944a5.238,5.238,0,0,0,2.388-.466,2.752,2.752,0,0,0,1.436-2.507A2.723,2.723,0,0,0,75.911,83.5a5.744,5.744,0,0,0-2.762-.528h-.6c-6.344,0-8.605,4.538-8.605,8.784v3.4h-.99a4.211,4.211,0,0,0-2.317.411,2.748,2.748,0,0,0,0,4.649,4.2,4.2,0,0,0,2.314.41h.99V122.2a5.6,5.6,0,0,0,.493,2.9,3.472,3.472,0,0,0,5.916-.005,5.594,5.594,0,0,0,.49-2.9V100.618h2.9a4.208,4.208,0,0,0,2.317-.411,2.748,2.748,0,0,0,0-4.649,4.209,4.209,0,0,0-2.315-.41h-2.9V92.02c0-2.079.824-3.027,2.672-3.076"
												transform="translate(-27.989 -39.12)"
												fill="#000a40" />
											<path id="Tracé_177"
												class="scroll-fade"
												data-name="Tracé 177"
												d="M118.183,118.963H105.461a8.283,8.283,0,0,1,.723-3.534,6.2,6.2,0,0,1,11.229,0l0,0a9.087,9.087,0,0,1,.768,3.532m-6.354-12.991c-8.156,0-13.223,6.083-13.223,15.875,0,10.237,4.982,15.875,14.027,15.875a14.873,14.873,0,0,0,8.118-2c2.142-1.371,3.229-2.721,3.229-4.01a3.077,3.077,0,0,0-2.914-3,4.343,4.343,0,0,0-2.73,1.192,8.767,8.767,0,0,1-5.554,1.817c-4.537,0-7.192-2.8-7.331-7.7H121.1a3.354,3.354,0,0,0,3.927-3.906c-.192-8.588-5.372-14.138-13.193-14.138"
												transform="translate(-46.494 -49.967)"
												fill="#000a40" />
											<path id="Tracé_178"
												class="scroll-fade"
												data-name="Tracé 178"
												d="M184.305,108.818a10.851,10.851,0,0,0-7.735-2.856,11.293,11.293,0,0,0-7.635,2.832,3.857,3.857,0,0,0-.521-1.477,3.531,3.531,0,0,0-5.662.112,5.643,5.643,0,0,0-.6,3.235v22.378a5.588,5.588,0,0,0,.493,2.9,3.472,3.472,0,0,0,5.916,0,5.6,5.6,0,0,0,.49-2.9V118.529c0-3.922,2.186-6.264,5.847-6.264,3.6,0,5.667,2.284,5.667,6.264v14.512a5.59,5.59,0,0,0,.494,2.9,3.472,3.472,0,0,0,5.916-.005,5.6,5.6,0,0,0,.49-2.894V117.635c0-3.965-.976-6.684-3.164-8.817"
												transform="translate(-76.459 -49.957)"
												fill="#000a40" />
										</g>
										<g id="Groupe_549"
											class="scroll-fade-up"
											data-name="Groupe 549">
											<path id="Tracé_179"
												data-name="Tracé 179"
												d="M42.628,37.66a3.451,3.451,0,1,1-3.452-3.452,3.452,3.452,0,0,1,3.452,3.452"
												transform="translate(-16.845 -16.13)"
												fill="#000a40" />
											<path id="Tracé_180"
												data-name="Tracé 180"
												d="M42.393,9.13l-.173.23a18.177,18.177,0,0,1-6.324,5.3,18.235,18.235,0,0,1-13.994,1.1,18.189,18.189,0,0,1-8.98-6.406l-.172-.229L11.106,10.75l.135.175A20.48,20.48,0,0,0,21.2,17.935a20.653,20.653,0,0,0,6.4,1.019A20.406,20.406,0,0,0,36.934,16.7,20.466,20.466,0,0,0,43.9,10.934l.136-.177Z"
												transform="translate(-5.237 -4.303)"
												fill="#977863" />
											<path id="Tracé_181"
												data-name="Tracé 181"
												d="M60.358,45.511a20.5,20.5,0,0,0-11.956.246A20.765,20.765,0,0,0,34.18,64.312l-.012.229,2.272.328.012-.276A18.439,18.439,0,0,1,49.108,47.931a18.216,18.216,0,0,1,10.781-.171l.267.079.42-2.266Z"
												transform="translate(-16.111 -21.095)"
												fill="#000a40" />
											<path id="Tracé_182"
												data-name="Tracé 182"
												d="M26.779,64.33a20.506,20.506,0,0,0-3.914-11.061A20.725,20.725,0,0,0,.6,45.537l-.22.061.42,2.26.266-.076a18.4,18.4,0,0,1,19.954,6.831,18.224,18.224,0,0,1,3.491,10l.012.277,2.273-.327Z"
												transform="translate(-0.177 -21.113)"
												fill="#000a40" />
											<path id="Tracé_183"
												data-name="Tracé 183"
												d="M42.692.1,42.605.079a2.1,2.1,0,0,0-2.527,1.275L38.341,5.963a2.155,2.155,0,0,1-1.22,1.285A2.037,2.037,0,0,1,34.5,6.065L32.722,1.354A2.1,2.1,0,0,0,30.2.079L30.109.1l-.271.079,2.454,6.509a4.525,4.525,0,0,0,3.05,2.841,4.327,4.327,0,0,0,5.1-2.663L42.963.184Z"
												transform="translate(-14.069 0)"
												fill="#51437e" />
											<path id="Tracé_184"
												data-name="Tracé 184"
												d="M72.653,26.984l-4.762-.251a2.167,2.167,0,0,1-1.6-.774,2.033,2.033,0,0,1,.332-2.856l4.056-3.2a2.1,2.1,0,0,0,.472-2.758l-.069-.109-.156-.241-5.72,4.516a4.327,4.327,0,0,0-.991,5.666,4.533,4.533,0,0,0,3.634,2.046l6.785.358v-.331a2.093,2.093,0,0,0-1.981-2.063"
												transform="translate(-29.972 -7.918)"
												fill="#004e9c" />
											<path id="Tracé_185"
												data-name="Tracé 185"
												d="M59.434,59.42a4.33,4.33,0,0,0-5.691.856,4.523,4.523,0,0,0-.789,4.089l1.65,5.972.266-.1.087-.032a2.1,2.1,0,0,0,1.287-2.517l-1.111-4.025a2.141,2.141,0,0,1,.233-1.751,2.041,2.041,0,0,1,2.814-.585l3.685,2.416a2.1,2.1,0,0,0,2.761-.42l.086-.1.18-.224Z"
												transform="translate(-24.884 -27.686)"
												fill="#f26611" />
											<path id="Tracé_186"
												data-name="Tracé 186"
												d="M19.939,60.26a4.337,4.337,0,0,0-5.69-.851L8.778,63l.182.225c.025.032.055.068.086.105a2.1,2.1,0,0,0,2.76.419l3.614-2.369a2.141,2.141,0,0,1,1.738-.314,2.039,2.039,0,0,1,1.417,2.5l-1.139,4.125a2.1,2.1,0,0,0,1.288,2.517l.087.032.265.1,1.655-5.989a4.509,4.509,0,0,0-.794-4.084"
												transform="translate(-4.139 -27.682)"
												fill="#e54182" />
											<path id="Tracé_187"
												data-name="Tracé 187"
												d="M9.432,21.307,3.71,16.788l-.156.241c-.021.034-.044.07-.068.109A2.1,2.1,0,0,0,3.957,19.9L8.016,23.1a2.037,2.037,0,0,1,.337,2.853,2.147,2.147,0,0,1-1.59.777l-4.8.252A2.077,2.077,0,0,0,0,29.046v.33l6.795-.358a4.523,4.523,0,0,0,3.632-2.048,4.328,4.328,0,0,0-.995-5.663"
												transform="translate(0 -7.916)"
												fill="#f09e28" />
											<path id="Tracé_188"
												data-name="Tracé 188"
												d="M14.6,2.728a20.68,20.68,0,0,1-.308,23.809,20.509,20.509,0,0,1-9.449,7.178l-.21.078L3.6,31.743l.266-.1a18.228,18.228,0,0,0,8.577-6.453A18.355,18.355,0,0,0,12.6,3.87l-.162-.231,2.027-1.1Z"
												transform="translate(-1.696 -1.199)"
												fill="#00aeb1" />
											<path id="Tracé_189"
												data-name="Tracé 189"
												d="M67.6,31.654A18.414,18.414,0,0,1,55.517,14.415,18.2,18.2,0,0,1,58.861,3.877l.163-.231L57,2.549l-.127.185a20.491,20.491,0,0,0-3.638,11.681A20.745,20.745,0,0,0,66.613,33.727l.211.079,1.037-2.054Z"
												transform="translate(-25.1 -1.202)"
												fill="#4fb06e" />
										</g>
									</g>
									<g id="Groupe_544"
										class="scroll-fade logo-baseline"
										data-name="Groupe 544"
										transform="translate(374.821 116.159)">
										<g id="Groupe_543"
											data-name="Groupe 543"
											transform="translate(0 0)">
											<path id="Tracé_190"
												data-name="Tracé 190"
												d="M0,10V.3A.127.127,0,0,1,.143.159H1.227A.127.127,0,0,1,1.37.3V10a.127.127,0,0,1-.143.143H.143A.127.127,0,0,1,0,10"
												transform="translate(0 -0.045)"
												fill="#000a40" />
											<path id="Tracé_191"
												data-name="Tracé 191"
												d="M10.9.16H11.98A.126.126,0,0,1,12.122.3v9.7a.126.126,0,0,1-.142.143H10.837a.168.168,0,0,1-.17-.1L7.228,3.129A.082.082,0,0,0,7.179,3.1c-.014,0-.021.014-.021.042l.014,6.864a.127.127,0,0,1-.143.143H5.943a.127.127,0,0,1-.142-.143V.3A.126.126,0,0,1,5.943.16H7.085a.168.168,0,0,1,.172.1l3.424,6.92a.074.074,0,0,0,.049.029c.014,0,.021-.014.021-.044V.3A.127.127,0,0,1,10.9.16"
												transform="translate(-1.649 -0.045)"
												fill="#000a40" />
											<path id="Tracé_192"
												data-name="Tracé 192"
												d="M19.373,9.881A2.535,2.535,0,0,1,18.3,8.946a2.568,2.568,0,0,1-.378-1.4V7.163a.126.126,0,0,1,.143-.143h1.056a.126.126,0,0,1,.142.143v.313A1.444,1.444,0,0,0,19.743,8.6a1.868,1.868,0,0,0,1.291.427,1.621,1.621,0,0,0,1.15-.393A1.348,1.348,0,0,0,22.6,7.6a1.284,1.284,0,0,0-.214-.742,2.241,2.241,0,0,0-.62-.585q-.408-.271-1.177-.685A14.205,14.205,0,0,1,19.2,4.78a3.062,3.062,0,0,1-.864-.9A2.408,2.408,0,0,1,18,2.568,2.366,2.366,0,0,1,18.782.685,3.052,3.052,0,0,1,20.864,0a3.492,3.492,0,0,1,1.583.342,2.548,2.548,0,0,1,1.063.963,2.7,2.7,0,0,1,.378,1.433v.329a.126.126,0,0,1-.142.142H22.676a.125.125,0,0,1-.142-.142v-.3a1.521,1.521,0,0,0-.457-1.141,1.712,1.712,0,0,0-1.242-.442,1.566,1.566,0,0,0-1.092.356,1.3,1.3,0,0,0-.391,1.013,1.316,1.316,0,0,0,.192.728,1.986,1.986,0,0,0,.593.564,12.589,12.589,0,0,0,1.184.663q.983.557,1.491.914a3,3,0,0,1,.827.87,2.3,2.3,0,0,1,.321,1.242,2.5,2.5,0,0,1-.806,1.954,3.123,3.123,0,0,1-2.176.728,3.64,3.64,0,0,1-1.6-.335"
												transform="translate(-5.097 0)"
												fill="#000a40" />
											<path id="Tracé_193"
												data-name="Tracé 193"
												d="M34.874.3v.913a.125.125,0,0,1-.142.142h-2.3a.05.05,0,0,0-.057.057V10a.127.127,0,0,1-.143.143H31.151A.127.127,0,0,1,31.008,10V1.414a.05.05,0,0,0-.057-.057h-2.2a.126.126,0,0,1-.143-.142V.3a.126.126,0,0,1,.143-.143h5.979A.126.126,0,0,1,34.874.3"
												transform="translate(-8.135 -0.045)"
												fill="#000a40" />
											<path id="Tracé_194"
												data-name="Tracé 194"
												d="M40.493,10V.3a.127.127,0,0,1,.143-.143H41.72A.127.127,0,0,1,41.863.3V10a.127.127,0,0,1-.143.143H40.636A.127.127,0,0,1,40.493,10"
												transform="translate(-11.514 -0.045)"
												fill="#000a40" />
											<path id="Tracé_195"
												data-name="Tracé 195"
												d="M51.8.3v.913a.125.125,0,0,1-.142.142h-2.3a.05.05,0,0,0-.057.057V10a.127.127,0,0,1-.143.143H48.077A.127.127,0,0,1,47.934,10V1.414a.05.05,0,0,0-.057-.057h-2.2a.126.126,0,0,1-.143-.142V.3A.126.126,0,0,1,45.68.159h5.979A.126.126,0,0,1,51.8.3"
												transform="translate(-12.948 -0.045)"
												fill="#000a40" />
											<path id="Tracé_196"
												data-name="Tracé 196"
												d="M58.748,9.884a2.624,2.624,0,0,1-1.071-1.071,3.292,3.292,0,0,1-.378-1.6V.3A.126.126,0,0,1,57.442.16h1.085A.125.125,0,0,1,58.669.3V7.294a1.81,1.81,0,0,0,.464,1.292,1.584,1.584,0,0,0,1.206.492,1.6,1.6,0,0,0,1.221-.492,1.81,1.81,0,0,0,.464-1.292V.3A.126.126,0,0,1,62.166.16h1.084A.126.126,0,0,1,63.392.3V7.209a3.284,3.284,0,0,1-.379,1.6,2.635,2.635,0,0,1-1.07,1.071,3.561,3.561,0,0,1-3.2,0"
												transform="translate(-16.293 -0.045)"
												fill="#000a40" />
											<path id="Tracé_197"
												data-name="Tracé 197"
												d="M75.087.3v.913a.125.125,0,0,1-.142.142h-2.3a.05.05,0,0,0-.057.057V10a.127.127,0,0,1-.143.143H71.364A.127.127,0,0,1,71.221,10V1.414a.05.05,0,0,0-.057-.057h-2.2a.126.126,0,0,1-.143-.142V.3a.126.126,0,0,1,.143-.143h5.979A.126.126,0,0,1,75.087.3"
												transform="translate(-19.569 -0.045)"
												fill="#000a40" />
											<path id="Tracé_198"
												data-name="Tracé 198"
												d="M85.71,10V.3a.127.127,0,0,1,.143-.143h2.9a2.94,2.94,0,0,1,2.118.756,2.652,2.652,0,0,1,.793,2.012V7.379a2.65,2.65,0,0,1-.793,2.012,2.935,2.935,0,0,1-2.118.756h-2.9A.127.127,0,0,1,85.71,10m1.427-1.041,1.641-.014a1.383,1.383,0,0,0,1.092-.464,1.885,1.885,0,0,0,.42-1.248V3.07a1.834,1.834,0,0,0-.413-1.262,1.422,1.422,0,0,0-1.114-.464H87.137a.05.05,0,0,0-.057.057V8.905c0,.039.018.058.057.058"
												transform="translate(-24.371 -0.045)"
												fill="#000a40" />
											<path id="Tracé_199"
												data-name="Tracé 199"
												d="M103.078,1.344H98.94a.05.05,0,0,0-.057.057V4.483a.05.05,0,0,0,.057.057h2.725a.126.126,0,0,1,.143.142v.9a.126.126,0,0,1-.143.142H98.94a.05.05,0,0,0-.057.057V8.905c0,.039.018.059.057.059h4.138a.126.126,0,0,1,.143.142v.9a.126.126,0,0,1-.143.142H97.655a.126.126,0,0,1-.142-.142V.3A.126.126,0,0,1,97.655.16h5.423a.127.127,0,0,1,.143.143v.9a.126.126,0,0,1-.143.142"
												transform="translate(-27.727 -0.045)"
												fill="#000a40" />
											<path id="Tracé_200"
												data-name="Tracé 200"
												d="M119.354,1.344H115.23a.05.05,0,0,0-.057.057V4.483a.05.05,0,0,0,.057.057h2.711a.126.126,0,0,1,.143.142v.9a.126.126,0,0,1-.143.142H115.23a.05.05,0,0,0-.057.057v4.225a.126.126,0,0,1-.143.142h-1.085a.126.126,0,0,1-.142-.142V.3a.126.126,0,0,1,.142-.143h5.408A.127.127,0,0,1,119.5.3v.9a.126.126,0,0,1-.143.142"
												transform="translate(-32.359 -0.045)"
												fill="#000a40" />
											<path id="Tracé_201"
												data-name="Tracé 201"
												d="M125.634,9.852a2.7,2.7,0,0,1-1.078-1.063,3.176,3.176,0,0,1-.385-1.584V3.01a3.142,3.142,0,0,1,.385-1.569A2.694,2.694,0,0,1,125.634.378a3.294,3.294,0,0,1,1.6-.378,3.337,3.337,0,0,1,1.612.378,2.685,2.685,0,0,1,1.085,1.063,3.142,3.142,0,0,1,.385,1.569V7.2a3.176,3.176,0,0,1-.385,1.584,2.694,2.694,0,0,1-1.085,1.063,3.337,3.337,0,0,1-1.612.378,3.294,3.294,0,0,1-1.6-.378m2.847-1.306a1.766,1.766,0,0,0,.471-1.284V2.981a1.821,1.821,0,0,0-.471-1.3,1.629,1.629,0,0,0-1.242-.5,1.605,1.605,0,0,0-1.226.5,1.815,1.815,0,0,0-.471,1.3V7.263a1.765,1.765,0,0,0,.471,1.277,1.619,1.619,0,0,0,1.226.492,1.654,1.654,0,0,0,1.242-.485"
												transform="translate(-35.307 0)"
												fill="#000a40" />
											<path id="Tracé_202"
												data-name="Tracé 202"
												d="M141,10.033l-1.654-4.252a.057.057,0,0,0-.058-.043h-1.527c-.039,0-.057.019-.057.058V10a.127.127,0,0,1-.143.143h-1.084a.127.127,0,0,1-.143-.143V.3a.127.127,0,0,1,.143-.143h3.2A2.5,2.5,0,0,1,141.6.943,2.9,2.9,0,0,1,142.324,3a2.966,2.966,0,0,1-.442,1.641,2.258,2.258,0,0,1-1.213.942c-.028.009-.037.034-.028.071l1.74,4.323.014.057c0,.076-.043.115-.128.115h-1.114a.158.158,0,0,1-.157-.115M137.7,1.4V4.6c0,.039.018.058.057.058h1.726a1.362,1.362,0,0,0,1.063-.45,1.7,1.7,0,0,0,.407-1.191,1.773,1.773,0,0,0-.4-1.213,1.352,1.352,0,0,0-1.07-.457h-1.726a.05.05,0,0,0-.057.057"
												transform="translate(-38.764 -0.045)"
												fill="#000a40" />
											<path id="Tracé_203"
												data-name="Tracé 203"
												d="M153.591.16h1.085a.126.126,0,0,1,.142.143v9.7a.127.127,0,0,1-.142.143h-1.085a.126.126,0,0,1-.142-.143V2.814c0-.029-.009-.044-.029-.049s-.034.007-.044.035l-1.7,2.81a.209.209,0,0,1-.172.1h-.228a.207.207,0,0,1-.172-.1L149.4,2.828c-.01-.029-.024-.039-.044-.036s-.027.021-.027.05v7.163a.127.127,0,0,1-.143.143H148.1a.127.127,0,0,1-.142-.143V.3A.126.126,0,0,1,148.1.16h1.085a.207.207,0,0,1,.17.1l2,3.225a.078.078,0,0,0,.086,0L153.42.259a.207.207,0,0,1,.17-.1"
												transform="translate(-42.07 -0.045)"
												fill="#000a40" />
											<path id="Tracé_204"
												data-name="Tracé 204"
												d="M165.97,10.02l-.427-1.655a.067.067,0,0,0-.072-.044h-3.153c-.048,0-.071.014-.071.044l-.414,1.655a.136.136,0,0,1-.156.128h-1.114a.12.12,0,0,1-.129-.157l2.64-9.7A.146.146,0,0,1,163.23.16h1.342a.147.147,0,0,1,.157.128l2.654,9.7.014.044c0,.075-.048.114-.142.114h-1.127a.147.147,0,0,1-.157-.128m-3.417-2.8a.069.069,0,0,0,.05.021h2.583a.069.069,0,0,0,.049-.021c.014-.014.017-.026.007-.036l-1.326-5.166c-.009-.019-.019-.029-.029-.029s-.019.009-.029.029L162.545,7.18c-.009.009-.007.021.007.036"
												transform="translate(-45.617 -0.045)"
												fill="#000a40" />
											<path id="Tracé_205"
												data-name="Tracé 205"
												d="M177.246.3v.913a.125.125,0,0,1-.142.142h-2.3a.05.05,0,0,0-.057.057V10a.127.127,0,0,1-.143.143h-1.084A.127.127,0,0,1,173.38,10V1.414a.05.05,0,0,0-.057-.057h-2.2a.126.126,0,0,1-.143-.142V.3a.126.126,0,0,1,.143-.143H177.1a.126.126,0,0,1,.142.143"
												transform="translate(-48.617 -0.045)"
												fill="#000a40" />
											<path id="Tracé_206"
												data-name="Tracé 206"
												d="M182.865,10V.3a.127.127,0,0,1,.143-.143h1.084a.127.127,0,0,1,.143.143V10a.127.127,0,0,1-.143.143h-1.084a.127.127,0,0,1-.143-.143"
												transform="translate(-51.996 -0.045)"
												fill="#000a40" />
											<path id="Tracé_207"
												data-name="Tracé 207"
												d="M189.792,9.852a2.7,2.7,0,0,1-1.078-1.063,3.175,3.175,0,0,1-.385-1.584V3.01a3.142,3.142,0,0,1,.385-1.569A2.694,2.694,0,0,1,189.792.378,3.294,3.294,0,0,1,191.4,0a3.337,3.337,0,0,1,1.612.378,2.685,2.685,0,0,1,1.085,1.063,3.142,3.142,0,0,1,.385,1.569V7.2a3.176,3.176,0,0,1-.385,1.584,2.694,2.694,0,0,1-1.085,1.063,3.337,3.337,0,0,1-1.612.378,3.294,3.294,0,0,1-1.6-.378m2.847-1.306a1.766,1.766,0,0,0,.471-1.284V2.981a1.821,1.821,0,0,0-.471-1.3,1.629,1.629,0,0,0-1.242-.5,1.605,1.605,0,0,0-1.226.5,1.815,1.815,0,0,0-.471,1.3V7.263a1.765,1.765,0,0,0,.471,1.277,1.619,1.619,0,0,0,1.226.492,1.654,1.654,0,0,0,1.242-.485"
												transform="translate(-53.549 0)"
												fill="#000a40" />
											<path id="Tracé_208"
												data-name="Tracé 208"
												d="M205.583.16h1.085A.126.126,0,0,1,206.81.3v9.7a.126.126,0,0,1-.142.143h-1.143a.168.168,0,0,1-.17-.1l-3.439-6.92a.082.082,0,0,0-.049-.029c-.014,0-.021.014-.021.042l.014,6.864a.127.127,0,0,1-.143.143h-1.085a.127.127,0,0,1-.142-.143V.3a.126.126,0,0,1,.142-.143h1.141a.168.168,0,0,1,.172.1l3.424,6.92a.074.074,0,0,0,.049.029c.014,0,.021-.014.021-.044V.3a.127.127,0,0,1,.143-.143"
												transform="translate(-57.007 -0.045)"
												fill="#000a40" />
											<path id="Tracé_209"
												data-name="Tracé 209"
												d="M0,32.863v-9.7a.127.127,0,0,1,.143-.143h2.9a2.94,2.94,0,0,1,2.118.756,2.652,2.652,0,0,1,.793,2.012v4.451a2.65,2.65,0,0,1-.793,2.012,2.935,2.935,0,0,1-2.118.756H.143A.127.127,0,0,1,0,32.863m1.427-1.041,1.641-.014a1.383,1.383,0,0,0,1.092-.464A1.885,1.885,0,0,0,4.58,30.1V25.929a1.833,1.833,0,0,0-.413-1.262A1.422,1.422,0,0,0,3.054,24.2H1.427a.05.05,0,0,0-.057.057v7.505c0,.039.018.058.057.058"
												transform="translate(0 -6.545)"
												fill="#000a40" />
											<path id="Tracé_210"
												data-name="Tracé 210"
												d="M17.368,24.2H13.23a.05.05,0,0,0-.057.057v3.082a.05.05,0,0,0,.057.057h2.725a.126.126,0,0,1,.143.142v.9a.126.126,0,0,1-.143.142H13.23a.05.05,0,0,0-.057.057v3.125c0,.039.018.058.057.058h4.138a.126.126,0,0,1,.143.142v.9a.127.127,0,0,1-.143.143H11.945a.127.127,0,0,1-.142-.143v-9.7a.126.126,0,0,1,.142-.143h5.423a.127.127,0,0,1,.143.143v.9a.127.127,0,0,1-.143.143"
												transform="translate(-3.356 -6.545)"
												fill="#000a40" />
											<path id="Tracé_211"
												data-name="Tracé 211"
												d="M28.093,32.864v-9.7a.127.127,0,0,1,.143-.143H29.32a.127.127,0,0,1,.143.143v8.6c0,.039.018.058.057.058h4.053a.125.125,0,0,1,.142.142v.9a.126.126,0,0,1-.142.143H28.236a.127.127,0,0,1-.143-.143"
												transform="translate(-7.988 -6.545)"
												fill="#000a40" />
											<path id="Tracé_212"
												data-name="Tracé 212"
												d="M37.372,25.941l-.129-2.74c0-.094.044-.142.129-.142h1.114c.085,0,.129.047.129.142l-.143,2.74a.127.127,0,0,1-.143.143h-.813a.127.127,0,0,1-.143-.143"
												transform="translate(-10.59 -6.556)"
												fill="#000a40" />
											<path id="Tracé_213"
												data-name="Tracé 213"
												d="M47.612,23.121H43.474a.05.05,0,0,0-.057.057V26.26c0,.039.018.058.057.058H46.2a.125.125,0,0,1,.142.142v.9a.126.126,0,0,1-.142.142H43.474a.05.05,0,0,0-.057.057v3.125c0,.039.018.058.057.058h4.138a.126.126,0,0,1,.143.142v.9a.127.127,0,0,1-.143.143H42.19a.127.127,0,0,1-.143-.143v-9.7a.127.127,0,0,1,.143-.143h5.422a.127.127,0,0,1,.143.143v.9a.127.127,0,0,1-.143.143m-3.439-2.148a.116.116,0,0,1,.014-.122l.842-1.541a.167.167,0,0,1,.17-.1h.914a.121.121,0,0,1,.115.05.123.123,0,0,1-.014.122l-1.028,1.554a.214.214,0,0,1-.17.086h-.729a.12.12,0,0,1-.114-.05"
												transform="translate(-11.956 -5.462)"
												fill="#000a40" />
											<path id="Tracé_214"
												data-name="Tracé 214"
												d="M53.334,32.863v-9.7a.127.127,0,0,1,.143-.143h2.9a2.941,2.941,0,0,1,2.118.756,2.652,2.652,0,0,1,.793,2.012v4.451a2.65,2.65,0,0,1-.793,2.012,2.936,2.936,0,0,1-2.118.756h-2.9a.127.127,0,0,1-.143-.143m1.427-1.041,1.641-.014a1.383,1.383,0,0,0,1.092-.464,1.885,1.885,0,0,0,.42-1.248V25.929a1.833,1.833,0,0,0-.413-1.262,1.422,1.422,0,0,0-1.114-.464H54.761a.05.05,0,0,0-.057.057v7.505c0,.039.018.058.057.058"
												transform="translate(-15.165 -6.545)"
												fill="#000a40" />
											<path id="Tracé_215"
												data-name="Tracé 215"
												d="M66.525,32.743a2.621,2.621,0,0,1-1.071-1.071,3.292,3.292,0,0,1-.378-1.6V23.161a.127.127,0,0,1,.142-.142H66.3a.126.126,0,0,1,.142.142v6.991a1.81,1.81,0,0,0,.463,1.292,1.585,1.585,0,0,0,1.206.492,1.6,1.6,0,0,0,1.221-.492,1.81,1.81,0,0,0,.464-1.292V23.161a.126.126,0,0,1,.142-.142h1.084a.127.127,0,0,1,.144.142v6.906a3.292,3.292,0,0,1-.379,1.6,2.641,2.641,0,0,1-1.071,1.071,3.293,3.293,0,0,1-1.605.379,3.26,3.26,0,0,1-1.589-.379"
												transform="translate(-18.504 -6.545)"
												fill="#000a40" />
											<path id="Tracé_216"
												data-name="Tracé 216"
												d="M78.307,32.711a2.6,2.6,0,0,1-1.071-1.027,3.049,3.049,0,0,1-.378-1.534V25.77a2.788,2.788,0,0,1,.834-2.119,3.469,3.469,0,0,1,4.4-.007,2.741,2.741,0,0,1,.827,2.083v.114a.153.153,0,0,1-.043.115.137.137,0,0,1-.1.043l-1.085.058a.127.127,0,0,1-.143-.143V25.7A1.568,1.568,0,0,0,79.9,24.043a1.643,1.643,0,0,0-1.2.457,1.6,1.6,0,0,0-.464,1.2v4.537a1.607,1.607,0,0,0,.464,1.2,1.646,1.646,0,0,0,1.2.457,1.568,1.568,0,0,0,1.655-1.655v-.2a.127.127,0,0,1,.143-.143l1.085.057a.126.126,0,0,1,.142.143v.1a2.974,2.974,0,0,1-.378,1.512,2.568,2.568,0,0,1-1.063,1.014,3.673,3.673,0,0,1-3.175-.007"
												transform="translate(-21.854 -6.5)"
												fill="#000a40" />
											<path id="Tracé_217"
												data-name="Tracé 217"
												d="M93.22,32.879l-.427-1.655a.067.067,0,0,0-.072-.044H89.567c-.048,0-.071.014-.071.044l-.414,1.655a.136.136,0,0,1-.156.128H87.812a.12.12,0,0,1-.129-.157l2.64-9.7a.146.146,0,0,1,.157-.128h1.342a.147.147,0,0,1,.157.128l2.654,9.7.014.044c0,.075-.048.114-.142.114H93.377a.147.147,0,0,1-.157-.128m-3.417-2.8a.069.069,0,0,0,.05.021h2.583a.069.069,0,0,0,.049-.021c.014-.014.017-.026.007-.036l-1.326-5.166c-.009-.019-.019-.029-.029-.029s-.019.009-.029.029L89.8,30.039c-.009.009-.007.021.007.036"
												transform="translate(-24.931 -6.545)"
												fill="#000a40" />
											<path id="Tracé_218"
												data-name="Tracé 218"
												d="M104.5,23.161v.913a.125.125,0,0,1-.142.142h-2.3a.05.05,0,0,0-.057.057v8.59a.127.127,0,0,1-.143.143h-1.084a.127.127,0,0,1-.143-.143v-8.59a.05.05,0,0,0-.057-.057h-2.2a.126.126,0,0,1-.143-.142v-.913a.126.126,0,0,1,.143-.143h5.979a.126.126,0,0,1,.142.143"
												transform="translate(-27.931 -6.545)"
												fill="#000a40" />
											<path id="Tracé_219"
												data-name="Tracé 219"
												d="M110.115,32.864v-9.7a.127.127,0,0,1,.143-.143h1.084a.127.127,0,0,1,.143.143v9.7a.127.127,0,0,1-.143.143h-1.084a.127.127,0,0,1-.143-.143"
												transform="translate(-31.31 -6.545)"
												fill="#000a40" />
											<path id="Tracé_220"
												data-name="Tracé 220"
												d="M117.04,32.712a2.7,2.7,0,0,1-1.078-1.063,3.176,3.176,0,0,1-.385-1.584V25.87a3.142,3.142,0,0,1,.385-1.569,2.694,2.694,0,0,1,1.078-1.063,3.294,3.294,0,0,1,1.6-.378,3.337,3.337,0,0,1,1.612.378,2.685,2.685,0,0,1,1.085,1.063,3.142,3.142,0,0,1,.385,1.569v4.194a3.176,3.176,0,0,1-.385,1.584,2.694,2.694,0,0,1-1.085,1.063,3.337,3.337,0,0,1-1.612.378,3.294,3.294,0,0,1-1.6-.378m2.847-1.306a1.766,1.766,0,0,0,.471-1.284V25.841a1.821,1.821,0,0,0-.471-1.3,1.629,1.629,0,0,0-1.242-.5,1.605,1.605,0,0,0-1.226.5,1.815,1.815,0,0,0-.471,1.3v4.281a1.765,1.765,0,0,0,.471,1.277,1.619,1.619,0,0,0,1.226.492,1.654,1.654,0,0,0,1.242-.485"
												transform="translate(-32.863 -6.5)"
												fill="#000a40" />
											<path id="Tracé_221"
												data-name="Tracé 221"
												d="M132.833,23.019h1.085a.126.126,0,0,1,.142.143v9.7a.126.126,0,0,1-.142.143h-1.143a.167.167,0,0,1-.17-.1l-3.439-6.92a.082.082,0,0,0-.049-.029c-.014,0-.021.014-.021.042l.014,6.864a.127.127,0,0,1-.143.143h-1.085a.127.127,0,0,1-.142-.143v-9.7a.126.126,0,0,1,.142-.143h1.141a.168.168,0,0,1,.172.1l3.424,6.92a.074.074,0,0,0,.049.029q.021,0,.021-.043V23.162a.127.127,0,0,1,.143-.143"
												transform="translate(-36.321 -6.545)"
												fill="#000a40" />
											<path id="Tracé_222"
												data-name="Tracé 222"
												d="M150.558,23.019h1.085a.126.126,0,0,1,.142.143v9.7a.126.126,0,0,1-.142.143H150.5a.167.167,0,0,1-.17-.1l-3.439-6.92a.082.082,0,0,0-.049-.029c-.014,0-.021.014-.021.042l.014,6.864a.127.127,0,0,1-.143.143h-1.085a.127.127,0,0,1-.142-.143v-9.7a.126.126,0,0,1,.142-.143h1.141a.168.168,0,0,1,.172.1l3.424,6.92a.074.074,0,0,0,.049.029q.021,0,.021-.043V23.162a.127.127,0,0,1,.143-.143"
												transform="translate(-41.361 -6.545)"
												fill="#000a40" />
											<path id="Tracé_223"
												data-name="Tracé 223"
												d="M162.741,32.879l-.427-1.655a.067.067,0,0,0-.072-.044h-3.153c-.048,0-.071.014-.071.044l-.414,1.655a.136.136,0,0,1-.156.128h-1.114a.121.121,0,0,1-.129-.157l2.64-9.7a.146.146,0,0,1,.157-.128h1.342a.147.147,0,0,1,.157.128l2.654,9.7.014.044c0,.075-.048.114-.142.114H162.9a.147.147,0,0,1-.157-.128m-3.417-2.8a.069.069,0,0,0,.05.021h2.583a.069.069,0,0,0,.049-.021c.014-.014.017-.026.007-.036l-1.326-5.166c-.009-.019-.019-.029-.029-.029s-.019.009-.029.029l-1.313,5.166c-.009.009-.007.021.007.036"
												transform="translate(-44.698 -6.545)"
												fill="#000a40" />
											<path id="Tracé_224"
												data-name="Tracé 224"
												d="M174.016,23.161v.913a.125.125,0,0,1-.142.142h-2.3a.05.05,0,0,0-.057.057v8.59a.127.127,0,0,1-.143.143h-1.084a.127.127,0,0,1-.143-.143v-8.59a.05.05,0,0,0-.057-.057h-2.2a.126.126,0,0,1-.143-.142v-.913a.126.126,0,0,1,.143-.143h5.979a.126.126,0,0,1,.142.143"
												transform="translate(-47.699 -6.545)"
												fill="#000a40" />
											<path id="Tracé_225"
												data-name="Tracé 225"
												d="M179.636,32.864v-9.7a.127.127,0,0,1,.143-.143h1.084a.127.127,0,0,1,.143.143v9.7a.127.127,0,0,1-.143.143h-1.084a.127.127,0,0,1-.143-.143"
												transform="translate(-51.078 -6.545)"
												fill="#000a40" />
											<path id="Tracé_226"
												data-name="Tracé 226"
												d="M186.562,32.712a2.708,2.708,0,0,1-1.078-1.063,3.183,3.183,0,0,1-.384-1.584V25.87a3.149,3.149,0,0,1,.384-1.569,2.7,2.7,0,0,1,1.078-1.063,3.3,3.3,0,0,1,1.6-.378,3.34,3.34,0,0,1,1.613.378,2.683,2.683,0,0,1,1.084,1.063,3.135,3.135,0,0,1,.386,1.569v4.194a3.168,3.168,0,0,1-.386,1.584,2.692,2.692,0,0,1-1.084,1.063,3.34,3.34,0,0,1-1.613.378,3.3,3.3,0,0,1-1.6-.378m2.848-1.306a1.768,1.768,0,0,0,.47-1.284V25.841a1.824,1.824,0,0,0-.47-1.3,1.63,1.63,0,0,0-1.243-.5,1.6,1.6,0,0,0-1.225.5,1.812,1.812,0,0,0-.472,1.3v4.281a1.762,1.762,0,0,0,.472,1.277,1.617,1.617,0,0,0,1.225.492,1.655,1.655,0,0,0,1.243-.485"
												transform="translate(-52.631 -6.5)"
												fill="#000a40" />
											<path id="Tracé_227"
												data-name="Tracé 227"
												d="M202.354,23.019h1.085a.126.126,0,0,1,.142.143v9.7a.126.126,0,0,1-.142.143H202.3a.167.167,0,0,1-.17-.1l-3.439-6.92a.082.082,0,0,0-.049-.029c-.014,0-.021.014-.021.042l.014,6.864a.127.127,0,0,1-.143.143H197.4a.127.127,0,0,1-.142-.143v-9.7a.126.126,0,0,1,.142-.143h1.141a.168.168,0,0,1,.172.1l3.424,6.92a.074.074,0,0,0,.049.029q.022,0,.021-.043V23.162a.127.127,0,0,1,.143-.143"
												transform="translate(-56.089 -6.545)"
												fill="#000a40" />
											<path id="Tracé_228"
												data-name="Tracé 228"
												d="M214.539,32.879l-.427-1.655a.067.067,0,0,0-.072-.044h-3.153c-.048,0-.071.014-.071.044l-.414,1.655a.136.136,0,0,1-.156.128h-1.114a.12.12,0,0,1-.129-.157l2.64-9.7a.146.146,0,0,1,.157-.128h1.342a.147.147,0,0,1,.157.128l2.654,9.7.014.044c0,.075-.048.114-.142.114H214.7a.147.147,0,0,1-.157-.128m-3.417-2.8a.07.07,0,0,0,.05.021h2.583a.069.069,0,0,0,.049-.021c.014-.014.017-.026.007-.036l-1.326-5.166c-.009-.019-.019-.029-.029-.029s-.019.009-.029.029l-1.313,5.166c-.009.009-.007.021.007.036"
												transform="translate(-59.427 -6.545)"
												fill="#000a40" />
											<path id="Tracé_229"
												data-name="Tracé 229"
												d="M221.624,32.864v-9.7a.127.127,0,0,1,.143-.143h1.084a.127.127,0,0,1,.143.143v8.6c0,.039.018.058.057.058H227.1a.125.125,0,0,1,.142.142v.9a.126.126,0,0,1-.142.143h-5.337a.127.127,0,0,1-.143-.143"
												transform="translate(-63.017 -6.545)"
												fill="#000a40" />
											<path id="Tracé_230"
												data-name="Tracé 230"
												d="M237.935,24.2H233.8a.05.05,0,0,0-.057.057v3.082a.05.05,0,0,0,.057.057h2.725a.126.126,0,0,1,.143.142v.9a.126.126,0,0,1-.143.142H233.8a.05.05,0,0,0-.057.057v3.125c0,.039.018.058.057.058h4.138a.126.126,0,0,1,.143.142v.9a.127.127,0,0,1-.143.143h-5.423a.127.127,0,0,1-.142-.143v-9.7a.126.126,0,0,1,.142-.143h5.423a.127.127,0,0,1,.143.143v.9a.127.127,0,0,1-.143.143"
												transform="translate(-66.072 -6.545)"
												fill="#000a40" />
										</g>
									</g>
								</g>
							</svg>
							<svg role="img"
								class="logo-scroll"
								xmlns="http://www.w3.org/2000/svg"
								width="69.296"
								height="33.025"
								viewBox="0 0 69.296 33.025">
								<title>Logo Ifen lors du défilement</title>
								<g id="Groupe_856"
									data-name="Groupe 856"
									transform="translate(-345.201 -85.975)">
									<path id="Tracé_175"
										data-name="Tracé 175"
										d="M38.326,105.972a2.39,2.39,0,0,0-2.226,1.247,4.211,4.211,0,0,0-.368,2.178v16.943a4.21,4.21,0,0,0,.371,2.182,2.611,2.611,0,0,0,4.447,0l0,0a4.21,4.21,0,0,0,.368-2.177V109.4a4.208,4.208,0,0,0-.371-2.181,2.388,2.388,0,0,0-2.224-1.243"
										transform="translate(309.472 -10.853)"
										fill="#000a40" />
									<path id="Tracé_176"
										data-name="Tracé 176"
										d="M70.01,87.463a3.94,3.94,0,0,0,1.8-.351,2.07,2.07,0,0,0,1.08-1.885,2.048,2.048,0,0,0-1.078-1.861,4.32,4.32,0,0,0-2.078-.4h-.448c-4.772,0-6.473,3.413-6.473,6.607V92.13h-.745a3.168,3.168,0,0,0-1.743.309,2.067,2.067,0,0,0,0,3.5,3.162,3.162,0,0,0,1.741.308h.745v16.235a4.215,4.215,0,0,0,.371,2.182,2.612,2.612,0,0,0,4.45,0A4.208,4.208,0,0,0,68,112.479V96.244h2.18a3.165,3.165,0,0,0,1.743-.309,2.067,2.067,0,0,0,0-3.5,3.166,3.166,0,0,0-1.741-.308H68V89.776c0-1.563.62-2.277,2.009-2.314"
										transform="translate(295.236 3.007)"
										fill="#000a40" />
									<path id="Tracé_177"
										data-name="Tracé 177"
										d="M113.331,115.743h-9.569a6.231,6.231,0,0,1,.544-2.658,4.663,4.663,0,0,1,8.446,0v0a6.835,6.835,0,0,1,.578,2.657m-4.779-9.771c-6.135,0-9.946,4.575-9.946,11.941,0,7.7,3.747,11.94,10.551,11.94a11.186,11.186,0,0,0,6.106-1.506c1.611-1.032,2.429-2.046,2.429-3.016a2.314,2.314,0,0,0-2.192-2.259,3.267,3.267,0,0,0-2.053.9,6.594,6.594,0,0,1-4.177,1.367c-3.413,0-5.41-2.106-5.514-5.792h11.766a2.523,2.523,0,0,0,2.953-2.938c-.145-6.46-4.04-10.634-9.923-10.634"
										transform="translate(271.59 -10.853)"
										fill="#000a40" />
									<path id="Tracé_178"
										data-name="Tracé 178"
										d="M178.816,108.107A8.162,8.162,0,0,0,173,105.959a8.494,8.494,0,0,0-5.743,2.13,2.9,2.9,0,0,0-.392-1.111,2.656,2.656,0,0,0-4.259.084,4.244,4.244,0,0,0-.449,2.433v16.831a4.2,4.2,0,0,0,.371,2.181,2.611,2.611,0,0,0,4.45,0,4.211,4.211,0,0,0,.368-2.178V115.411c0-2.95,1.644-4.711,4.4-4.711,2.709,0,4.263,1.718,4.263,4.711v10.915a4.2,4.2,0,0,0,.371,2.181,2.611,2.611,0,0,0,4.45,0,4.213,4.213,0,0,0,.368-2.177V114.739c0-2.982-.734-5.028-2.38-6.632"
										transform="translate(233.302 -10.839)"
										fill="#000a40" />
									<path id="Tracé_179"
										data-name="Tracé 179"
										d="M40.917,36.8a2.6,2.6,0,1,1-2.6-2.6,2.6,2.6,0,0,1,2.6,2.6"
										transform="translate(309.476 52.385)"
										fill="#000a40" />
								</g>
							</svg>
							<img src="/img/pictos/divers/logo_header_mobile.png"
								alt="Logo de l'Institut de Formation de l'Éducation Nationale" />
						</a>
						<div class="mobile-nav">
							<ul class="mobile-nav-pictos">
								<li>
									<a href="/ifen/catalog/"
										aria-label="Accéder au catalogue">
										<img src="/img/pictos/divers/picto_catalogue_mobile.svg"
											width="30"
											height="30"
											alt="Pictogramme Catalogue mobile" />
									</a>
								</li>
								<li>
									<a href="/ifen/my"
										aria-label="Accéder à MyIfen">
										<img src="/img/pictos/divers/picto_myifen_mobile.svg"
											width="30"
											height="30"
											alt="Pictogramme MyIfen mobile" />
									</a>
								</li>
							</ul>
							<button class="collapsed mobile-nav-burger"
								role="bouton"
								type="button"
								aria-label="Toggle navigation">
								<span />
								<span />
								<span />
							</button>
						</div>

						<div class="collapse navbar-collapse">
							<div class="navbar-nav ml-auto">
								<div class="navbar-nav-wrapper">
									<div class="menu-menu-principal-container">
										<ul id="menu-menu-principal"
											class="menu">
											<li class="menu-item">
												<a href="/ifen/linstitut/">L’Institut</a>
											</li>
											<li class="menu-item">
												<a href="/ifen/je-suis/">Je suis</a>
											</li>
											<li class="menu-item">
												<a href="/ifen/ressources/">Ressources</a>
											</li>
											<li class="menu-item">
												<a href="/ifen/contact/">Contact</a>
											</li>
											<li class="wp-block-button menu-item">
												<a href="/ifen/catalog/">
													<span>
														<svg xmlns="http://www.w3.org/2000/svg"
															xmlns:xlink="http://www.w3.org/1999/xlink"
															width="17.074"
															height="15.815"
															viewBox="0 0 17.074 15.815">
															<g id="Groupe_861"
																data-name="Groupe 861"
																transform="translate(0 0)">
																<g id="Groupe_860"
																	data-name="Groupe 860">
																	<path id="Tracé_530"
																		data-name="Tracé 530"
																		d="M8.5,15.315,2.456,13.472V.522L8.5,2.253,14.6.5V13.494Z"
																		fill="none"
																		stroke="#fff"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																		stroke-width="1" />
																	<path id="Tracé_531"
																		data-name="Tracé 531"
																		d="M8.5,2.254V15.316l-8-.675V1.58l1.933.247"
																		fill="none"
																		stroke="#fff"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																		stroke-width="1" />
																	<path id="Tracé_532"
																		data-name="Tracé 532"
																		d="M8.571,15.315l8-.674V1.579l-1.933.247"
																		fill="none"
																		stroke="#fff"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																		stroke-width="1" />
																</g>
															</g>
														</svg>
														Catalogue
													</span>
												</a>
											</li>
											<li class="wp-block-button menu-item">
												<a href="/ifen/my">
													<span>
														<svg xmlns="http://www.w3.org/2000/svg"
															xmlns:xlink="http://www.w3.org/1999/xlink"
															width="12.505"
															height="13.661"
															viewBox="0 0 12.505 13.661">
															<g id="Groupe_859"
																data-name="Groupe 859"
																transform="translate(0 0)">
																<g id="Groupe_858"
																	data-name="Groupe 858">
																	<circle id="Ellipse_47"
																		data-name="Ellipse 47"
																		cx="3.09"
																		cy="3.09"
																		r="3.09"
																		transform="translate(3.312 0.5)"
																		fill="none"
																		stroke="#fff"
																		stroke-miterlimit="10"
																		stroke-width="1" />
																	<path id="Tracé_529"
																		data-name="Tracé 529"
																		d="M.5,13.661V12.433a5.753,5.753,0,0,1,11.505,0v1.228"
																		fill="none"
																		stroke="#fff"
																		stroke-miterlimit="10"
																		stroke-width="1" />
																</g>
															</g>
														</svg>
														MyIfen
													</span>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>
	</div>
</template>
